import { TranslatableModel } from './translatable-model';
import { AccessorsMutatorsDecorator } from '../../helpers/model';
import { Property } from './property.model';

export class PropertyAccommodationType extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return ['description'];
    }

    static get MALE_GENDER() {

        return {
            key: 'male',
            value: 'MALE',
        };
    }

    static get MALE_FEMALE() {

        return {
            key: 'female',
            value: 'FEMALE',
        };
    }

    static get MALE_MIXED_BOTH() {

        return {
            key: 'both',
            value: 'MIXED_BOTH',
        };
    }

    static get GENDERS() {

        return [
            this.MALE_GENDER,
            this.MALE_FEMALE,
            this.MALE_MIXED_BOTH,
        ];
    }

    static get GENDERS_MAP() {

        return this.GENDERS.reduce((obj, {key, value}) => {
            obj[key] = value;
            return obj;
        }, {});
    }

    static get DEFAULT_NTMP_TYPE() {

        return 13;
    }

    fill(attribute = {}) {
        
        super.fill(attribute);
        
        if (angular.isUndefined(this.room_numbers)) {
            
            this.room_numbers = [{abbreviation: `(1)`, saved: 0}];
        }
        
        if (angular.isUndefined(this.private_or_shared)) {
            
            this.private_or_shared = 0;
        }
        
        if (this.private_or_shared === 0) {
            
            this.room_numbers_length = this.attributes['room_numbers'].length;
            this.number_of_shared_dorm_rooms = 1;
            this.dorm_beds_per_room = 1;
            
        } else {
            
            this.room_numbers_length = 1;
        }
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

    setMaximumOccupancy(value) {

        return value !== null ? value : 1;
    }

    getMaximumOccupancy(value) {

        if (angular.isUndefined(value)) {

            this.maximum_occupancy = 1;
        }

        return this.private_or_shared !== 1 ? value : null;
    }

    setAdultsIncludedInRate(value) {

        return value !== null ? value : 1;
    }

    getAdultsIncludedInRate(value) {

        if (angular.isUndefined(value)) {

            this.adults_included_in_rate = 1;
        }

        return this.private_or_shared !== 1 ? value : null;
    }

    setChildrenIncludedInRate(value) {

        return value !== null ? value : 0;
    }

    getChildrenIncludedInRate(value) {

        if (angular.isUndefined(value)) {

            this.children_included_in_rate = 0;
        }

        return this.private_or_shared !== 1 ? value : null;
    }

    getNumberOfSharedDormRooms(value) {

        return this.private_or_shared !== 0 ? value : null;
    }

    getDormBedsPerRoom(value) {

        return this.private_or_shared !== 0 ? value : null;
    }

    setSharedRoomGender(value) {

        return value !== null ? value : 'male';
    }

    getSharedRoomGender(value) {

        if (angular.isUndefined(value)) {

            this.shared_room_gender = 'male';
        }

        return this.private_or_shared !== 0 ? value : null;
    }

    getRoomNumbersLength(value) {

        return this.private_or_shared !== 1 ? value : null;
    }
    
    getRoomNumbers(value) {
        
        if (!angular.isUndefined(value)) {
            
            const limit = this.private_or_shared === 1 ? this.number_of_shared_dorm_rooms * this.dorm_beds_per_room : this.room_numbers_length;
            
            if (limit === null) {
                
                return [{ abbreviation: `(${value.length + 1})`, saved: 0 }];
            }
            
            while (limit > value.length) {
                
                value.push({
                    abbreviation: angular.isUndefined(this.abbreviation) ? `(${value.length + 1})` : `${this.abbreviation} (${value.length + 1})`,
                    saved: 0
                });
            }
            
            return value.slice(0, limit);
        }
    }
    
    setAbbreviation(value) {
        
        const limit = this.private_or_shared === 1 ? this.number_of_shared_dorm_rooms * this.dorm_beds_per_room : this.room_numbers_length;
        
        (this.attributes['room_numbers'] || []).map((x, index) => {
            
            if (!x.saved || index >= limit) {
                
                x.abbreviation = angular.isUndefined(value) ? `(${index + 1})` : `${value} (${index + 1})`;
            }
            return x;
        });
        
        return value;
    }

    formatSharedRoomGender(value) {

        return this.constructor.GENDERS_MAP[this.shared_room_gender];
    }

    get total_accommodations() {
        if (this.private_or_shared === 0) {
            return this.room_numbers.length;
        } else {
            return this.number_of_shared_dorm_rooms * this.dorm_beds_per_room;
        }
    }

    get number_of_all_units() {
        if (this.private_or_shared === 0) {

            return this.room_numbers.length;

        } else {

            return this.number_of_shared_dorm_rooms;
        }
    }

    get min_rank_rate() {
        return this.quantity === 0 || !this.quantity ? 0 : 1;
    }

    static get validationModel() {

        return {
            name: {
                label: 'ACCOMMODATION_TYPE_NAME_IN_ENGLISH',
                commonLabel: 'Accommodation Type Name'
            },
            name_ar: {
                label: 'ACCOMMODATION_TYPE_NAME_IN_ARABIC',
                commonLabel: 'Accommodation Type Name'
            },
            description: {
                label: 'DESCRIPTION_IN_ENGLISH',
                commonLabel: 'Description'
            },
            description_ar: {
                label: 'DESCRIPTION_IN_ARABIC',
                commonLabel: 'Description'
            }
        };
    }
}

AccessorsMutatorsDecorator(
    'id',
    ...PropertyAccommodationType.translatableAttributesWithLanguageAliases,
    'name',
    'name_ar',
    'logo',
    'images',
    'abbreviation',
    'private_or_shared',
    'number_of_units',
    'property',
    'room_numbers',
    'maximum_occupancy',
    'adults_included_in_rate',
    'children_included_in_rate',
    'number_of_shared_dorm_rooms',
    'dorm_beds_per_room',
    'shared_room_gender',
    'custom_amenities',
    'room_amenities',
    'room_numbers_length',
    'order',
    'addon_intervals',
    'free_rooms_quantity',
    'base_rates',
    'reservation_accommodations_count',
    'rate_plan_intervals',
    'ntmp_type_id',
    'staah_room_type',
    'staah_room_type_id',
    'rack_rate',
    'size',
    'size_unit',
    'quantity',
    'daily_min_price',
    'daily_from_price',
    'daily_to_price'
)(PropertyAccommodationType);



// WEBPACK FOOTER //
// ./src/pms-api/models/property-accommodation-type.model.js